import Brand from '../helpers/brand';
import uuidv4 from 'uuid/v4';

type UUID = Brand<string, 'UUID'>;

export default UUID;

export const uuid = () => {
  return uuidv4() as UUID;
};
